import styled from 'vue3-styled-components';

export const PageContainer = styled.div`
  min-height: 100vh;
  padding: 24px;
`;

// Main Card Container
export const MainCard = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05);
  }
`;

// Search Section
export const SearchSection = styled.div`
  padding: 25px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
`;

export const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 24px 0;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #3b82f6, #8b5cf6);
    border-radius: 2px;
  }
`;

export const SearchForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SearchFormInput = styled.input`
  width: 350px;
  padding: 11px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 5px;
  font-size: 14px;
  background: white;
  
  &:focus {
    outline: none;
    border-color: #0f4c5c;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
    transform: translateY(-1px);
  }
  
  &::placeholder {
    color: #9ca3af;
  }
`;

export const SearchButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  background: #0f4c5c;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  
  &:hover:not(:disabled) {
    transform: translateY(-2px);
  }
  
  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
    border-color: #9ca3af;
  }
`;

// Transactions Section
export const TransactionsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
  background: white;
  border-bottom: 1px solid #f3f4f6;
`;

export const TransactionsActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  
  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 8px;
    margin-left: 0;
  }
`;

export const FilterSelect = styled.select`
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  color: #374151;
  
  &:focus {
    outline: none;
    border-color: #0f4c5c;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: white;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f9fafb;
    border-color: #9ca3af;
  }
`;

export const RefreshButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(16, 185, 129, 0.3);
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4);
  }
`;

export const FilterIcon = styled.span`
  font-size: 12px;
`;

export const DownloadIcon = styled.span`
  font-size: 12px;
`;

// Table Styles
export const TransactionsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-top: 1px solid #e5e7eb;
  padding: 10px;
`;

export const TransactionsTableHeader = styled.thead`
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
`;

export const TransactionsTableBody = styled.tbody`
  background: white;
`;

export const TransactionsTableRow = styled.tr`
  transition: all 0.1s ease;
  
  &:hover {
    background: #f8fafc;
  }
  
  &:not(:last-child) {
    border-bottom: 1px solid #f3f4f6;
  }
`;

export const TransactionsTableHeaderCell = styled.th`
  padding: 16px 12px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #e5e7eb;
`;

export const TransactionsTableCell = styled.td`
  padding: 16px 12px;
  text-align: center;
  font-size: 14px;
  color: #1f2937;
  border-bottom: 1px solid #f3f4f6;
`;

// Transaction Amount Styles
export const WithdrawalAmount = styled.span`
  color: #dc2626;
  font-weight: 600;
`;

export const DepositAmount = styled.span`
  color: #2563eb;
  font-weight: 600;
`;

export const BalanceAmount = styled.span`
  font-weight: 600;
  color: #1f2937;
`;

export const MemoLink = styled.span`
  color: #3b82f6;
  cursor: pointer;
  text-decoration: underline;
  font-size: 13px;
  transition: color 0.2s ease;
  
  &:hover {
    color: #1d4ed8;
  }
`;

// Empty States
export const EmptyTransactionState = styled.div`
  padding: 60px 32px;
  text-align: center;
  background: white;
`;

export const EmptyIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
`;

export const EmptyTitle = styled.h4`
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 8px 0;
`;

export const EmptyDescription = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
`;

// ClaimPage에서 가져온 스타일 컴포넌트들
export const ClaimListButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  
  &:hover {
    background: linear-gradient(135deg, #1a6b7a 0%, #0f4c5c 100%);
    transform: translateY(-1px);
  }
`;

export const DateSelectionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DateInput = styled.input`
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  
  &:focus {
    outline: none;
    border-color: #0f4c5c;
  }
`;

export const DateSeparator = styled.span`
  color: #6b7280;
  font-size: 12px;
`;

export const DateDisplay = styled.span`
  font-size: 13px;
  color: #374151;
`;

export const AmountDisplay = styled.span`
  font-weight: 700;
  color: #059669;
  font-family: 'Courier New', monospace;
`;

// =====================================================
// 탭 네비게이션 스타일
// =====================================================

export const TabNavigation = styled.div`
  display: flex;
  gap: 8px;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 0;
`;

export const TabButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  color: #64748b;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px 8px 0 0;

  &:hover {
    background: #f8fafc;
    color: #475569;
  }

  &.active {
    background: #f8fafc;
    color: #1e293b;
    border-bottom-color: #3b82f6;
    font-weight: 600;
  }

  &.active svg {
    color: #3b82f6;
  }
`;

// 고정 댓글 관련 스타일
export const PinnedRow = styled(TransactionsTableRow)`
    background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
    border-left: 4px solid #f59e0b;
    box-shadow: 0 2px 8px rgba(245, 158, 11, 0.15);
    position: relative;

    &:hover {
        background: linear-gradient(135deg, #fde68a 0%, #fcd34d 100%);
        box-shadow: 0 4px 12px rgba(245, 158, 11, 0.25);
    }
`;

export const CommentCell = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
`;

export const CommentText = styled.span`
    cursor: pointer;
    text-decoration: underline;
    color: #6b7280;
    font-size: 13px;
    flex: 1;
`;

export const PinnedBadge = styled.div`
    background: linear-gradient(135deg, #f59e0b, #d97706);
    color: white;
    padding: 2px 6px;
    border-radius: 12px;
    font-size: 10px;
    font-weight: 600;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    animation: pulse 2s infinite;

    @keyframes pulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
    }
`;

export const PinActions = styled.div`
    display: flex;
    gap: 6px;
    align-items: center;
    justify-content: center;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 4px;
    }
`;

export const PinButton = styled.button`
    background: linear-gradient(135deg, #f3f4f6, #e5e7eb);
    border: 2px solid #d1d5db;
    border-radius: 8px;
    padding: 6px 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 32px;

    &:hover {
        background: linear-gradient(135deg, #e5e7eb, #d1d5db);
        border-color: #9ca3af;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }

    &.pinned {
        background: linear-gradient(135deg, #fef3c7, #fde68a);
        border-color: #f59e0b;
        box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);

        &:hover {
            background: linear-gradient(135deg, #fde68a, #fcd34d);
            border-color: #d97706;
        }
    }

    @media (max-width: 768px) {
        min-width: 28px;
        height: 28px;
        padding: 4px 6px;
    }
`;

export const PinIcon = styled.span`
    font-size: 14px;
    transition: transform 0.2s ease;

    ${PinButton}:hover & {
        transform: scale(1.1);
    }

    @media (max-width: 768px) {
        font-size: 12px;
    }
`;

export const AddCommentButton = styled.button`
    background: linear-gradient(135deg, #dbeafe, #bfdbfe);
    border: 2px solid #93c5fd;
    border-radius: 8px;
    padding: 6px 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 32px;
    color: #1e40af;

    &:hover {
        background: linear-gradient(135deg, #bfdbfe, #93c5fd);
        border-color: #60a5fa;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
    }

    @media (max-width: 768px) {
        min-width: 28px;
        height: 28px;
        padding: 4px 6px;
    }
`;